import { toastr } from 'react-redux-toastr';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import history from '~/services/history';
import { ResponseProps } from '../../../propsGlobal/responseProps';
import {
  assuntoContactFailure,
  assuntoContactRequest,
  assuntoContactSuccess,
  contactDPOFailure,
  contactDPORequest,
} from './actions';
import { contactDPOTLogadoTypes } from './types';

function toBase64(file: any) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });
}

async function convertFileToBase64(props: any) {
  let filesBase64 = [];
  let params = {
    files: props.file,
    country_company: props.country_company,
    content: props.content,
    email: props.email,
    identification_key: props.identification_key,
    ownership_type: props.ownership_type,
    subject: props.subject,
  };

  for (let index = 0; index < params.files.length; index++) {
    let base64 = (await toBase64(params.files[index])) as string;
    filesBase64.push({
      name: params.files[index].name,
      base64: base64.replace(/^data:(.*,)?/, ''),
    });
  }

  let header = {
    headers: {
      Authorization: null,
      company: props.country_company,
      'g-recaptcha-response': props.recaptcha,
    },
  };

  params.files = filesBase64;
  api.post('/v1/tickets', params, header);
}

function* contact({ payload }: ReturnType<typeof contactDPORequest>) {
  const { ...props } = payload.contactDPO;

  props.identification_key = props.identification_key.replace(/[^\d]+/g, '');

  try {
    if (props.file) {
      convertFileToBase64(props);
    }

    const toastrConfirmOptions = {
      onOk: () => history.push('/sky-br/home'),
      onCancel: () => {},
      okText: 'Ok',
      disableCancel: true,
    };

    toastr.confirm(
      'Solicitação efetuada com sucesso. Entraremos em contato com a resposta.',
      toastrConfirmOptions,
    );
  } catch (error) {
    const toastrConfirmOptions = {
      onOk: () => {},
      onCancel: () => {},
      okText: 'Ok',
      disableCancel: true,
    };

    toastr.confirm(
      'Problemas no acesso ao servidor. Por favor, tente mais tarde.',
      toastrConfirmOptions,
    );
    yield put(contactDPOFailure());
  }
}

function* assunto({ payload }: ReturnType<typeof assuntoContactRequest>) {
  const { company } = payload;

  try {
    const response: ResponseProps = yield call(api.get, '/v1/assuntos', {
      headers: { Authorization: null, company },
    });

    yield put(assuntoContactSuccess(response.data));
  } catch (error) {
    yield put(assuntoContactFailure());
  }
}

export default all([
  takeLatest(contactDPOTLogadoTypes.CONTACT_DPO_RESQUEST, contact),
  takeLatest(contactDPOTLogadoTypes.ASSUNTO_CONTACT_RESQUEST, assunto),
]);
